<template>
  <div class="continer">
    <HeaderTop></HeaderTop>
    <CompanyTitle></CompanyTitle>
    <RouterList></RouterList>
    <Banner></Banner>
    <!-- 面包屑 -->
    <div class="navigation">
      <span>当前位置&nbsp;:&nbsp;</span>
      <router-link to="/">&nbsp;首页&nbsp;>&nbsp;</router-link>
      <router-link to="/drawing">审查流程</router-link>
    </div>
    <div class="picImg">
      <img src="../assets/img/image006.png" alt="">
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import HeaderTop from '@/components/header-top/header-top.vue'
import CompanyTitle from '@/components/company-title/company-title.vue'
import RouterList from '@/components/router-list/router-list.vue'
import Banner from '@/components/banner/banner.vue'
import Footer from '@/components/footer/footer.vue'
export default {
  components: {
    HeaderTop,
    CompanyTitle,
    RouterList,
    Banner,
    Footer
  },
  data() {
    return {
      
    }
  },
}
</script>
<style lang="stylus" scoped>
.continer
  .navigation
    width 1200px
    height 52px
    background rgba(255,255,255,1)
    margin 30px auto 10px
    box-shadow 0px 0px 10px 0px rgba(0, 0, 0, 0.05)
    font-size 12px
    padding 18px 20px
    box-sizing border-box
    span,a 
      color #666666
    a:nth-child(3)
      color #3377FF
  .picImg
    width 1200px
    height 1216px
    line-height 1216px
    margin 0 auto 100px
    background rgba(255,255,255,1)
    box-shadow 0px 0px 10px 0px rgba(0, 0, 0, 0.05)
    text-align center
    img
      margin-top 88px
      transform scale(1)
</style>